$(function() {
  $('#circles-search-members').on('keyup', function() {
    if ($(this).val().length > 2) {
      Rails.fire($('#circles-members-search-form')[0], 'submit');
    } else {
      $('#circles-members-dropdown').addClass('hidden');
    }
  });

  $('#circles-search-members').on('blur', function(e) {
    $('#circles-members-dropdown').addClass('hidden');
  });

  $('#circles-members-dropdown').on('mousedown', '.connection-bar', function(e) {
    e.stopPropagation();
    e.preventDefault();

    $('#circles-members-dropdown').addClass('hidden');
    $('#circles-search-members').val('');

    const clone = $('.circles-results__item-hidden').clone(true);
    $(clone).find('.avatar__image').attr('src', $(this).data('img'));
    $(clone).find('.avatar__image').attr('alt', $(this).data('name'));
    $(clone).find('.circles-suggest__name a').text($(this).data('name'));
    $('.circle-results').append(clone);
    $(clone).addClass('circles-results__item-clone');
    $(clone).removeClass('hidden');
    $(clone).removeClass('circles-results__item-hidden');

    // add email needed to pass to invite to circle form
    $(clone).append('<input type="hidden" name="emails[]" value="' + $(this).data('email') + '" />');
  });

  $('.circle-results').on('click', '.circles-suggest__cancel', function() {
    $(this).closest('.circles-results__item').remove();
  })

  $('.panel-invite__alternative').on('click', function() {
    if ($(this).closest('.panel-invite-members').length) {
      $(this).closest('.panel-invite-members').addClass('hidden');
      $('.panel-invite-email').removeClass('hidden');
    }
    if ($(this).closest('.panel-invite-email').length) {
      $(this).closest('.panel-invite-email').addClass('hidden');
      $('.panel-invite-members').removeClass('hidden');
    }
  });

  $('.panel-invite-email .input__widget').on('click', function() {
    $(this).addClass('hidden');
    $('#invite-emails-input').removeClass('hidden');
    $('#invite-emails-input').focus();
  })
});
